import { RootState } from 'src/store';
import { HelpButtonState } from './types';

export const selectHelpButton = (state: RootState): HelpButtonState => state.helpButton;

export const selectIsHelpButtonShowing = (state: RootState) => selectHelpButton(state).isShowing;
export const selectHasSeenNewUserEducationModal = (state: RootState) =>
  selectHelpButton(state).hasSeenNewUserEducationModal;
